import { faEdit } from "@fortawesome/pro-regular-svg-icons";
import { faCircle } from "@fortawesome/pro-solid-svg-icons";

import { Button } from "src/base-components/Button";
import { Card } from "src/base-components/Card";
import { Icon } from "src/base-components/Icon";
import {
  Agent,
  AgentVersion,
  AgentVersionStatus,
} from "src/clients/agent-management";
import { UserNameInfo } from "src/flowContainer/versionEditedInfo/UsernameInfo";
import { formatDate } from "src/utils/datetime";

type Props = {
  agent: Agent;
  version: AgentVersion;
  immutable: boolean;
  handleChangeAgent: () => void;
};

const LastEdited: React.FC<{ version: AgentVersion }> = ({ version }) => {
  const userId =
    version.metadata.updated_by_id || version.metadata.created_by_id;

  return (
    <div className="flex flex-row items-center gap-x-1">
      <p className="text-gray-600 font-inter-normal-12px">Edited by</p>
      <div className="flex items-center gap-x-1 text-gray-800">
        <UserNameInfo userId={userId} withAvatar />
      </div>
      <p className="text-gray-600 font-inter-normal-12px">on</p>
      <p className="text-gray-800 font-inter-medium-12px">
        {formatDate(version.metadata.updated_at)}
      </p>
    </div>
  );
};

const StatusIndicator: React.FC<{ status: AgentVersionStatus }> = ({
  status,
}) => {
  const isPublished = status === AgentVersionStatus.PUBLISHED;
  return (
    <Icon
      color={isPublished ? "text-green-400" : "text-yellow-400"}
      icon={faCircle}
      size="2xs"
    />
  );
};

export const SelectedAgentDisplay: React.FC<Props> = ({
  agent,
  version,
  handleChangeAgent,
  immutable,
}) => {
  return (
    <Card>
      <Card.Header>
        <div className="flex flex-row items-center gap-x-1">
          <StatusIndicator status={version.status} />
          <p
            className="text-gray-800 font-inter-semibold-14px"
            data-loc="agent-selected-version-display-header"
          >
            {agent.name}
            {", "}
            {version.name}
          </p>
        </div>
      </Card.Header>
      <div className="space-y-1 pt-1">
        <p className="whitespace-pre-line text-gray-500 font-inter-normal-12px">
          {agent.description}
        </p>
        <LastEdited version={version} />
      </div>
      <div className="mt-3">
        <Button
          disabled={immutable}
          iconLeft={faEdit}
          size="sm"
          variant="secondary"
          onClick={handleChangeAgent}
        >
          Change Agent
        </Button>
      </div>
    </Card>
  );
};
